var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { createSelector, useStorage } from 'master-hook';
import { STORAGE_NAME } from './constants';
export var lastError = createSelector(function () { return useStorage(STORAGE_NAME).errors; }, function (errors) {
    return __spreadArray([], errors, true).pop();
});
